// 测评
export default [{ // 测评列表
  path: '/evaluationList',
  name: 'evaluationList',
  component: resolve => require(['@/views/evaluation/evaluationList.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 测评-量表列表
  path: '/evaluationScaleList',
  name: 'evaluationScaleList',
  component: resolve => require(['@/views/evaluation/evaluationScaleList.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 测评-量表详情
  path: '/scaleDetails',
  name: 'scaleDetails',
  component: resolve => require(['@/views/evaluation/scaleDetails.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 测评-量表填写
  path: '/scaleWrite',
  name: 'scaleWrite',
  component: resolve => require(['@/views/evaluation/scaleWrite.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/evaluation/evaluation.js